export * from './common'
export * from './menu'
export * from './testimonialSlider'
export * from './loadPosts'
export * from './customForms'
export * from './search'
export * from './imageSlider'
export * from './backgroundVideo'



// WEBPACK FOOTER //
// ./scripts/func/index.js